import axios from 'axios';
import { jwtDecode } from 'jwt-decode';
import dayjs from 'dayjs';
import { getLocalStorage, isMobileApp, setLocalStorage } from '../../common/common';
import packageJson from '../../../package.json';
import { onlineManager } from 'react-query';
import { toast } from 'react-toastify';
const baseURL = process.env.REACT_APP_API_URL;
const authService = process.env.REACT_APP_API_URL;
const apiVersion = packageJson.version;

let accessToken = ''; /// getLocalStorage('accessToken', '') ? getLocalStorage('accessToken', '') : null;
accessToken = getLocalStorage('accessToken', '') ? getLocalStorage('accessToken', '') : null;
// let refreshToken = getLocalStorage('refreshToken', '') ? getLocalStorage('refreshToken', '') : null;
const nodeServiceInstance = axios.create({
  baseURL,
  headers: {
    Authorization: getLocalStorage('accessToken', ''),
    version: isMobileApp() ? `rjsa ${apiVersion}` : `rjsw ${apiVersion}`
  }
});
const isOnline = onlineManager.isOnline();
nodeServiceInstance.interceptors.request.use(
  async (req) => {
    if (!accessToken) {
      accessToken = getLocalStorage('accessToken', '') ? getLocalStorage('accessToken', '') : null;
      req.headers.Authorization = accessToken;
    }
    let access = ''; //jwtDecode(accessToken);
    access = jwtDecode(accessToken);
    let isExpired = '';
    isExpired = dayjs.unix(access.exp).diff(dayjs()) < 1;

    //console.group('AXIOS_INSTANCE', req);
    if (isOnline) {
      if (!isExpired) {
        accessToken = null;
        return req;
      } else {
        accessToken = null;
        try {
          const response = await axios.post(`${authService}auth/getAccessToken`, {
            token: getLocalStorage('refreshToken', '')
          });
          setLocalStorage('accessToken', response.data.data.token);
          req.headers.Authorization = response.data.data.token;
          return req;
        } catch (error) {
          try {
            const response = await axios.post(`${authService}auth/getRefreshToken`, {
              token: getLocalStorage('refreshToken', '')
            });

            setLocalStorage('accessToken', response.data.data.token);
            setLocalStorage('refreshToken', response.data.data.refresh_token);
            req.headers.Authorization = response.data.data.token;
            return req;
          } catch (error) {
            window.location.href = window.location.origin;
            localStorage.clear();
            sessionStorage.clear();
            return Promise.reject('loginAgain');
          }
        }
      }
    } else {
      toast.error('Please make sure you have an active internet connection');
    }
  },
  async (error) => {
    return Promise.reject(error);
  }
);

nodeServiceInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    const originalRequest = error.config;
    if (error?.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      try {
        const res = await axios.post(`${authService}auth/getAccessToken`, {
          token: getLocalStorage('refreshToken', '')
        });
        if (res.data.status_code == 200) {
          // 1) put token to LocalStorage
          setLocalStorage('accessToken', res.data.data.token);
          // 2) Change Authorization header
          originalRequest.headers.Authorization = res.data.data.token;
          // 3) return originalRequest object with Axios.
          //console.groupEnd('AXIOS_INSTANCE_response_error', error);
          return axios(originalRequest);
        }
      } catch (error) {
        console.log('error', error);
      }
    }

    return Promise.reject(error);
  }
);
export default nodeServiceInstance;
